import { useId } from 'react';
import classes from './spinner.module.scss';

type SpinnerProps = {
  /** Base colour of the blobs. Anything CSS accepts; defaults to the brand primary. */
  color?: string;
  /** Rendered size in pixels. */
  size?: number;
};

export default function Spinner(props: SpinnerProps) {
  const { color = 'var(--primary)', size = 48 } = props;
  // Filter and gradient ids have to be unique per instance, otherwise several spinners on
  // the same page all resolve to whichever one mounted first.
  const uid = useId().replace(/:/g, '');
  const gooId = `blob-goo-${uid}`;
  const gradientId = `blob-gradient-${uid}`;

  return (
    <div className={classes.Root} style={{ '--blob-size': `${size}px` } as React.CSSProperties} role="status" aria-live="polite">
      <svg className={classes.Svg} viewBox="0 0 100 100" aria-hidden="true">
        <defs>
          <filter id={gooId}>
            {/* Blur then crank up alpha contrast: neighbouring shapes bleed into one another
                and the sharpened alpha turns that bleed into a single welded outline. */}
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
            <feColorMatrix
              in="blur"
              type="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -9"
              result="goo"
            />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.75" />
            <stop offset="100%" stopColor={color} />
          </linearGradient>
        </defs>

        <g className={classes.Goo} filter={`url(#${gooId})`} fill={`url(#${gradientId})`}>
          <circle className={classes.Core} cx="50" cy="50" r="13" />
          <g className={classes.Orbit}>
            <circle className={classes.Blob} cx="50" cy="50" r="12" />
          </g>
          <g className={classes.Orbit}>
            <circle className={classes.Blob} cx="50" cy="50" r="12" />
          </g>
          <g className={classes.Orbit}>
            <circle className={classes.Blob} cx="50" cy="50" r="12" />
          </g>
        </g>
      </svg>
      <span className="sr-only">جاري التحميل</span>
    </div>
  );
}
